import React, { useContext, useEffect, useState } from "react";
import { Col,Row as MRow } from "react-bootstrap";
import { openModal } from "@redq/reuse-modal";
import { Modal } from "react-bootstrap";
import RadioCard from "../../../components/RadioCard/RadioCard";
import PaymentRadioCard from "../../../components/PaymentRadioCard/PaymentRadioCard";
import { ProfileContext } from "../../../contexts/profile/profile.context";
// import StripePaymentForm from '../../Payment/StripePaymentForm';
import {
  SettingsForm,
  SettingsFormContent,
  HeadingSection,
  Title,
  Input,
  Row,
  ButtonGroup,
  PaymentGroupButton,
} from "./Settings.style";
import RadioGroup from "../../../components/RadioGroup/RadioGroup";
// import PaymentGroup from '../../../components/PaymentGroup/PaymentGroup';
import UpdateAddress from "../../CheckoutWithSidebar/Update/UpdateAddress";
import UpdateProfile from "./UpdateProfile";
import Button from "../../../components/Button/Button";
import PageLoader from "../../../components/PageLoader/PageLoader";
import { FormattedMessage } from "react-intl";
import { Plus } from "../../../components/AllSvgIcon";
import { Tab, Tabs } from "react-bootstrap";
import t from "../../../i18n/translate";
import _ from "lodash";
import WalletManagementComponent from "../../../components/WalletManagement/WalletManagement";
import DelipointManagementComponent from "../../../components/DelipointManagement/DelipointManagement";
import { colors, FormControlLabel, Button as MButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@material-ui/core';
import Switch  from 'react-switch';
import API from "../../../network/redAPI";
import { useStoreLogo } from "../../../contexts/store-logo/use-storeLogo";
import Logo from "../../../components/Logo/Logo";
import deliExpressLogo from '../../../assets/icons/delixpress_logo2.svg';
import deliShopLogo from '../../../assets/icons/delishop_logo2.svg';
import { CurrencyFormat } from "../../../util/currencyFormat";
import moment from "moment";
import CustomerAddress from "../../../components/CustomerAddress/CustomerAddress";
const SettingsContent = ({ deviceType, props }) => {
  const { state, dispatch } = useContext(ProfileContext);
  const [active, setActive] = useState("details");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [mailSubscribeStatus, setMailSubscribeStatus] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [copiedIndex, setCopiedIndex] = useState(null); // State to track which coupon was copied
    const { storeLogo, fetchStoreLogo } = useStoreLogo();
  const copyCoupon = (coupon, index) => {
    navigator.clipboard.writeText(coupon).then(() => {
      setCopiedIndex(index); // Set the index of the copied coupon
      setTimeout(() => setCopiedIndex(null), 2000); // Reset after 2 seconds
    });
  };
  const handleChange = (value, field) => {
    dispatch({
      type: "HANDLE_ON_INPUT_CHANGE",
      payload: { value, field },
    });
  };
  let user = localStorage.getItem("user");
  let parsedUser = JSON.parse(user);
  if (!parsedUser) {
    // window.location.href = "/";
  }
  // Add or edit modal
  const [addressModal, setAddressModal] = useState(false)
  const [addressModalType, setAddressModalType] = useState("add")
  const [selectedAddressToUpdate, setSelectedAddressToUpdate] = useState(null);

  const handleModal = (
      modalComponent,
      modalProps = {},
      type,
      className = "add-address-modal edit-profile"
  ) => {
    openModal({
      show: true,
      config: {
        // width: 360,
        enableResizing: false,
        disableDragging: true,
        className: className,
      },
      closeOnClickOutside: false,
      component: modalComponent,
      componentProps: { item: modalProps, type, props },
    });
  };
  const handleUpdateAddress = (component,item,type) => {
    setAddressModalType(type)
    setAddressModal(!addressModal)
  };


  const handleEditDelete = async (item, type, name) => {
    setSelectedAddressToUpdate(item)
    if (type === "edit") {
      const modalComponent = name === "address" ? UpdateAddress : UpdateProfile;
      handleUpdateAddress(modalComponent, item, "edit");
    } else if (type === "delete") {
      if (item.is_default) {
        alert(t("shop_checkout_cant_delete_default_address_error", false));
      } else {
        let response = window.confirm(
          t("shop_checkout_confirm_delete_address", false)
        );
        if (response === true) {
          props.deleteAddress({ address_id: item.address_id });
        }
      }
    } else {
    }
  };
  const handleDeletePaymentMethod = async (id) => {
    let response = window.confirm(
      "Are you sure you want to delete this payment information ?"
    );
    if (response === true) {
      props.deletePaymentMethod(id, dispatch);
    }
  };

  const handleSave = async () => {
    const { name, email } = state;
    // await updateMeMutation({
    //   variables: { meInput: JSON.stringify({ name, email }) },
    // });
  };

  function onChangePassword() {
    if (_.isEmpty(newpassword) || _.isEmpty(confirmpassword)) {
      alert(t("change_password_empty_error", false));
    } else if (newpassword !== confirmpassword) {
      alert(t("change_password_and_confirm_didnt_match", false));
    } else {
      props.doLoggedInPasswordChange({
        newpassword,
        confirmpassword,
        email: parsedUser.email,
      });
      alert(t("change_password_success_message", false));
    }
  }
  const getCustomerMailSubscribe = async () => {
    await API.getCustomerMailSubscribe(JSON.parse(user)?.email)
      .then((response) => response.json())
      .then((response) => {
      // Handle the response here
        if(response.success){
          setMailSubscribeStatus(response.data.status.email === "active" ? true : false);
        }
      })
      .catch((error) => {
        console.error("Failed to get customer mail subscribe status:", error);
      });
  };
  const updateCustomerMailSubscribe = async () => {
    setUpdating(true)
    await API.customerUpdateMailSubscribe(JSON.parse(user)?.email)
      .then((response) => response.json())
      .then((response) => {
      // Handle the response here
        if(response.success){
          getCustomerMailSubscribe()
          setUpdating(false)
        }else{
          setUpdating(false)
        }
      })
      .catch((error) => {
        setUpdating(false)
        console.error("Failed to get customer mail subscribe status:", error);
      });
  };
  useEffect(() => {
    getCustomerMailSubscribe()
  },[]);

  const [couponFetching,setCouponFetching] = useState(false);
  const [couponList,setCouponList] = useState([]);
  const [orderCouponList,setOrderCouponList] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  const getCouponList = async () => {
      setCouponFetching(true)
        await API.getAllCustomerPickCouponCode({
          user_id: JSON.parse(user)?.cust_id
        })
        .then((res) => res.json())
        .then((res) => {
          if(res.success) {
            setCouponFetching(false)
            setCouponList(res.data?.coupons)
            setOrderCouponList(res.data?.order)
          }else{
            setCouponFetching(false)
            setCouponList([])
          }
      });
    };
    useState(() => {
      getCouponList()
    },[]);
  return (
    <SettingsForm>
      <SettingsFormContent>
        {parsedUser && (
          <Tabs
            id="controlled-tab-example"
            activeKey={active}
            onSelect={(k) => setActive(k)}
            className="tabProfile"
          >
            <Tab
              eventKey={"details"}
              title={t("profile_user_section_info_title", false)}
            >
              <HeadingSection>
                <Title>{t("profile_user_title")}</Title>
              </HeadingSection>
              <Row style={{ alignItems: "flex-end", marginBottom: "50px" }}>
                <Col xs={12} sm={4} md={3} lg={3}>
                  <Input
                    type="email"
                    label={t("profile_user_full_name_input_title", false)}
                    value={parsedUser.first_name + " " + parsedUser.last_name}
                    onUpdate={(value) => handleChange(value, "name")}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="profileNameField"
                    disabled
                  />
                </Col>

                <Col xs={12} sm={4} md={3} lg={3}>
                  <Input
                    type="email"
                    label={t("profile_user_email_title", false)}
                    value={parsedUser.email}
                    onUpdate={(value) => handleChange(value, "email")}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="profileEmailField"
                    disabled
                  />
                </Col>
                <Col xs={12} sm={4} md={3} lg={3}>
                  <Input
                    type="email"
                    label={t("profile_user_phone_title", false)}
                    value={
                      "+" + parsedUser.country_code + "-" + parsedUser.phone
                    }
                    onUpdate={(value) => handleChange(value, "mobile")}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="profileMobileField"
                    disabled
                  />
                </Col>
                <Col xs={12} sm={4} md={3} lg={2}>
                  <Input
                    type="text"
                    label={'Nationality'}
                    value={parsedUser?.nationality||"undefined"}
                    onUpdate={(value) => handleChange(value, "nationality")}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="profileNationalityField"
                    disabled
                  />
                </Col>
                <Col xs={12} sm={2} md={2} lg={1}>
                  <Button
                    title={t("profile_user_change_button", false)}
                    className="addButton"
                    type="button"
                    onClick={() =>
                      handleModal(UpdateProfile, "add-profile-modal", "add")
                    }
                    style={{ width: "100%" }}
                    intlButtonId="profileSaveBtn"
                  />
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey={"password"}
              title={t("profile_user_section_password_title", false)}
            >
              <HeadingSection>
                <Title>{t("change_password_new_password_title")}</Title>
              </HeadingSection>
              <Row style={{ alignItems: "flex-end", marginBottom: "50px" }}>
                <Col xs={12} sm={4} md={3} lg={3}>
                  <Input
                    type="password"
                    show={showPassword}
                    label={t("change_password_new_password_input_hint", false)}
                    value={""}
                    onUpdate={(value) => setNewPassword(value)}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="newPasswordField"
                    setShowPassword={setShowPassword}
                  />
                </Col>
                <Col xs={12} sm={4} md={3} lg={3}>
                  <Input
                    type="password"
                    show={showCPassword}
                    label={t(
                      "change_password_confirm_password_input_hint",
                      false
                    )}
                    value={""}
                    onUpdate={(value) => {
                      setConfirmPassword(value);
                      if (confirmpassword !== undefined) {
                        // enter a password !
                      } else if (confirmpassword !== newpassword) {
                        alert(
                          t("change_password_and_confirm_didnt_match", false)
                        );
                        // password not matched !
                      } else {
                        // no error
                        alert(t("change_password_and_confirm_matched", false));
                      }
                    }}
                    style={{ backgroundColor: "#F7F7F7" }}
                    intlInputLabelId="confirmPasswordField"
                    setShowPassword={setShowCPassword}
                  />
                </Col>
                <Col xs={12} sm={2} md={2} lg={2}>
                  <Button
                    title={t("change_password_update_button")}
                    className="addButton"
                    type="button"
                    onClick={onChangePassword}
                    style={{ width: "100%" }}
                    intlButtonId="passwordSaveBtn"
                  />
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey={"address"}
              title={t("profile_user_section_address_title", false)}
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ position: "relative" }}
                >
                  <SettingsFormContent>
                    {props.loading && <PageLoader />}
                    <HeadingSection>
                      <Title>{t("setting_shop_addresses")}</Title>
                    </HeadingSection>
                    <ButtonGroup>
                      <RadioGroup
                        items={
                          props.user_address != undefined
                            ? props.user_address
                            : []
                        }
                        component={(item) => (
                          <RadioCard
                            id={item.address_id}
                            key={item.address_id ? item.address_id : item.id}
                            title={item.nick_name}
                            firstName={item.first_name}
                            lastName={item.last_name ? item.last_name : null}
                            value={item.address_id}
                            content={item.area_details}
                            house_number={item.house_number}
                            apartment_name={item.apartment_name}
                            street_details={item.street_details}
                            mobile_number={item.mobile_number}
                            country_code={item.country_code}
                            city={item.city}
                            landmark={item.landmark}
                            pin_code={item.pin_code}
                            commune={item.commune}
                            district={item.district}
                            house_and_street={item.house_and_street}
                            delivery_instructions={item.delivery_instructions}
                            name="address"
                            checked={item.is_default == 1}
                            onChange={() => {}}
                            onEdit={() =>
                              handleEditDelete(item, "edit", "address")
                            }
                            onDelete={() =>
                              handleEditDelete(item, "delete", "address")
                            }
                          />
                        )}
                        secondaryComponent={
                          <Button
                            className="addButton"
                            title={t("profile_user_add_address_button", false)}
                            icon={<Plus width="10px" />}
                            iconPosition="left"
                            colors="primary"
                            size="small"
                            variant="textButton"
                            type="button"
                            intlButtonId="addNew"
                            onClick={() =>
                                handleUpdateAddress(
                                null,
                                null,
                                "create"
                              )
                            }
                          />
                        }
                      />
                    </ButtonGroup>
                  </SettingsFormContent>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey={"wallet"}
              title={t("profile_user_section_wallet_title", false)}
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ position: "relative" }}
                >
                  <SettingsFormContent>
                    {props.loading && <PageLoader />}
                    <WalletManagementComponent />
                  </SettingsFormContent>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey={"delipoint"}
              title={t("profile_user_section_delipoint_title", false)}
            >
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ position: "relative" }}
                >
                  <SettingsFormContent>
                    {props.loading && <PageLoader />}
                    <DelipointManagementComponent />
                  </SettingsFormContent>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey={"payment"} title={`${t("payment_method")}`}>
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ position: "relative" }}
                >
                  <SettingsFormContent>
                    {props.loading && <PageLoader />}
                    <HeadingSection>
                      <Title>{`${t("manage_payment_method")}`}</Title>
                    </HeadingSection>
                    <PaymentGroupButton>
                      <RadioGroup
                        items={
                          props.user_paymentMethod != undefined
                            ? props.user_paymentMethod
                            : []
                        }
                        component={(item) => (
                          <PaymentRadioCard
                            id={item.id}
                            value={item.id}
                            name="paymentMethode"
                            cust_id={item.cust_id}
                            card_token={item.card_token}
                            swift_code={item.swift_code}
                            holder_name={item.holder_name}
                            account_logo={item.account_logo}
                            account_number={item.account_number}
                            account_name={item.account_name}
                            month={item.month}
                            year={item.year}
                            isExpired={item.is_expired}
                            onChange={() => {}}
                            hasEdit={false}
                            onDelete={() => handleDeletePaymentMethod(item.id)}
                          />
                        )}
                      />
                    </PaymentGroupButton>
                  </SettingsFormContent>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey={"subscription_action"} title={`${t("my_subscription")}`}>
              <Typography variant="h5" className="mb-2 font-weight-bold text-capitalize">{t("email")}</Typography>
              <Row sm={12}>
                <Col
                  xs={12}
                  sm={12}
                  md={3}
                  lg={3}
                  style={{ position: "relative" }}
                >
                   <label className="d-flex justify-content-between">
                     <Typography variant="h6" className="mr-3">{updating ? "updating..." : "Newsletter"}</Typography>
                      <Switch
                        className={`react-switch ${!!mailSubscribeStatus ? "active" : ""}`}
                        onChange={() => updateCustomerMailSubscribe()}
                        checked={!!mailSubscribeStatus}
                      />
                  </label>
                </Col>
              </Row>
            </Tab>
            <Tab eventKey={"my_coupon_action"} title={`${t("my_coupons")}`}>
              {/* <Typography variant="h5" className="mb-2 font-weight-bold">Email</Typography> */}
              <Typography variant="h6">{`${t("coupons")}`}</Typography>
              <MRow sm={12}>
                {couponFetching ? (
                  <span>loading...</span>
                ) : couponList.length > 0 ? (
                  couponList.map((coupon, index) => (
                    <Col sm={6} md={6} lg={6} xl={4} className="my-1" key={index}>
                      <div className="card">
                        <div className="card-grid">
                          <div className="co-img">
                            <img
                              alt="logo"
                              src={
                                props.cartType === "express"
                                  ? deliExpressLogo
                                  : deliShopLogo
                              }
                            />
                          </div>
                          <div className="vertical"></div>
                          <div className="content">
                            <h2>{coupon.name}</h2>
                            <p>
                              <p>
                                {coupon.description.length > 50
                                    ? expandedIndex === index
                                        ? coupon.description
                                        : `${coupon.description.slice(0, 50)}...`
                                    : coupon.description}
                              </p>

                            </p>

                            {coupon.description.length > 50 && <span onClick={() => toggleExpand(index)} className="see-more-btn">
                              {expandedIndex === index ? t("see_less") : t("see_more")}
                            </span>}
                            <h1>
                              {coupon?.discountPercentage
                                ? coupon?.discountPercentage + " % "
                                : coupon?.discountFixedPrice
                                ? CurrencyFormat(coupon?.discountFixedPrice)
                                : "-"}
                            </h1>
                            <p>
                              {t("valid_till")}{" "}
                              {moment(coupon?.validTo).format("YYYY-MM-DD")}
                              {/* {moment(coupon?.validTo).format("YYYY-MM-DD HH:mm:ss")} */}
                            </p>
                          </div>
                        </div>
                        <div className="copy-button">
                          <div className="input-wrapper">
                            <input
                              type="text"
                              readOnly
                              className="coupon-input"
                            />
                            <div className="blurred-text">{coupon.code}</div>
                          </div>
                          <button
                            onClick={() => copyCoupon(coupon.code, index)}
                            className="copybtn text-uppercase"
                          >
                            {copiedIndex === index ? t("copied") : t("copy")}
                          </button>
                        </div>
                      </div>
                    </Col>
                  ))
                ) : <Typography>Not Coupon Found</Typography>}
              </MRow>
              <Typography variant="h6" className="mt-2">{t("order_hasUsed_coupon")}</Typography>
              <MRow className="mt-2" sm={12}>
              <TableContainer style={{ maxHeight: window.innerHeight - 220 }}>
                  <Table stickyHeader>
                   <TableHead>
                      <TableRow>
                          <TableCell align="center">{t("coupon_code")}</TableCell>
                          <TableCell align="center">{t("order_id")}</TableCell>
                          <TableCell align="center">{t("order_amount")}</TableCell>
                          <TableCell align="center">{t("coupon_discount_amount")}</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody style={{ position: "relative" }}>
                      {couponFetching ? (
                        <>loading...</>
                      ) : orderCouponList.length > 0 ? (
                        orderCouponList.map((order, index) => (
                          <TableRow key={index} hover>
                            <TableCell align="center">{order?.coupon_code.code}</TableCell>
                            <TableCell align="center">{order.order_id}</TableCell>
	                          <TableCell align="center">{CurrencyFormat(order.amount)}</TableCell>
                            <TableCell align="center">{order?.coupon_code?.percentage
                                ? order?.coupon_code?.percentage + " % "
                                : order?.coupon_code?.fixed
                                ? CurrencyFormat(order?.coupon_code?.fixed)
                                : "-"}</TableCell>
                          </TableRow>
                        ))
                      ) : <TableCell colSpan={4} align="center">Not order Found</TableCell>}
                  </TableBody>
                </Table>
              </TableContainer>
              </MRow>
            </Tab>
          </Tabs>
        )}
      </SettingsFormContent>
      {/*//address modal*/}
      {addressModal &&
          <CustomerAddress
              props={props}
              open={addressModal}
              handleToggleModal={handleUpdateAddress}
              selectedAddressToUpdate={selectedAddressToUpdate}
              setSelectedAddressToUpdate={setSelectedAddressToUpdate}
              type={addressModalType}
          />
      }
    </SettingsForm>
  );
};

export default SettingsContent;
